import Path from '../../../services/paths'
import utils from '../../common/utils'
import ChannelAction from '../../prat_actions/gt/channelAction'
import CustomToast from '../../../util-functions/customToast.jsx'

export default class GeoMiddleware {
    static get_masterChannel(currentForm){
        let url = currentForm === 'ic' ? Path.GET_ICE_CREAM_MASTER_CHANNEL : Path.GET_MASTER_CHANNEL
        return dispatch => {
            dispatch(ChannelAction.masterChannel_Request());
            utils.get_token()
            .then(token => {
                fetch(url , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(ChannelAction.masterChannel_Success(data))
                })
                .catch(err => {
                    if(err.message === 'Failed to fetch'){
                        CustomToast('warning', 'Please check your internet connection')
                    }
                    dispatch(ChannelAction.masterChannel_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(ChannelAction.masterChannels_Failed(err.message))

            })
        }
    };

    // CHANNEL

    static get_channel(){
        return dispatch => {
            dispatch(ChannelAction.channel_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_CHANNEL , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(ChannelAction.channel_Success(data))
                })
                .catch(err => {
                    dispatch(ChannelAction.channel_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(ChannelAction.geoAreas_Failed(err.message))

            })
        }
    };

    //  ELEMENT

    static get_elements(){
        return dispatch => {
            dispatch(ChannelAction.element_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_ELEMENT , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(ChannelAction.element_Success(data))
                })
                .catch(err => {
                    dispatch(ChannelAction.element_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(ChannelAction.element_Failed(err.message))

            })
        };
    };

     static get_subElements(){
        return dispatch => {
            dispatch(ChannelAction.subElement_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_SUB_ELEMENT , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    dispatch(ChannelAction.subElement_Success(data))
                })
                .catch(err => {
                    dispatch(ChannelAction.subElement_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(ChannelAction.subElement_Failed(err.message))

            })
        }
    };

}

